import React from 'react';
import {
  BrowserRouter, Route, Switch,
} from 'react-router-dom';
import { useSelector } from 'react-redux';
import Zendesk, { ZendeskAPI } from 'react-zendesk';
import { useTranslation } from 'react-i18next';
import Login from './pages/Login';
import Home from './pages/Home';
import Manager from './pages/Manager';
import Fuel from './pages/Fuel';
import Contracts from './pages/Contracts';
import Search from './pages/Search';
import DailyParts from './pages/DailyParts';
import Underground from './pages/Underground';
import Maintenance from './pages/Maintenance';
import Dispatch from './pages/Dispatch';
import Quality from './pages/Quality';
import Telemetry from './pages/Telemetry';
import Configuration from './pages/Configuration';
import Lineup from './pages/Lineup';
import Admin from './pages/Admin';
import Password from './pages/PasswordRedefiniton';
import Dynamic from './pages/Dynamic';
import Expedite from './pages/Expedite';
import PrivateRoute from './routeGuard/privateRoute';
import SocketioConnection from './components/SocketioConnection';

const ZENDESK_KEY = '85b7c368-1bff-42ce-8a4e-8133c612da1c';

const Routes = () => {
  const { t: translate } = useTranslation();
  const isUserAuthenticated = useSelector(state => state.auth.isAuthenticated);

  const renderZendeskWidget = () => (
    <Zendesk
      defer
      zendeskKey={ZENDESK_KEY}
      onRender={() => {
        ZendeskAPI('webWidget', 'hide');
      }}
    />
  );

  return (
    <BrowserRouter>
      {isUserAuthenticated && <SocketioConnection key={String(isUserAuthenticated)} />}
      <Switch>
        <Route exact path="/login" component={Login} />
        <PrivateRoute exact path="/" component={Home} />
        <PrivateRoute
          path="/manager"
          component={Manager}
          userAccessLevel={[1, 2, 3]}
          requiredModule="ManagementModule"
        />
        <PrivateRoute
          path="/fuel"
          component={Fuel}
          userAccessLevel={[1, 2, 3]}
          requiredModule="FuelModule"
        />
        <PrivateRoute
          path="/contracts"
          component={Contracts}
          userAccessLevel={[1, 2, 3]}
          requiredModule="ContractsModule"
        />
        <PrivateRoute
          path="/underground"
          component={Underground}
          userAccessLevel={[1, 2, 3]}
          requiredModule="UndergroundModule"
        />
        <PrivateRoute
          path="/maintenance"
          component={Maintenance}
          userAccessLevel={[1, 2, 3]}
          requiredModule="MaintenanceModule"
        />
        <PrivateRoute
          path="/dispatch"
          component={Dispatch}
          userAccessLevel={[1, 2, 3]}
        />
        <PrivateRoute
          path="/quality"
          component={Quality}
          userAccessLevel={[1, 2, 3]}
        // requiredModule="Qualidade"
        />
        <PrivateRoute
          path="/telemetry"
          component={Telemetry}
          userAccessLevel={[1, 2, 3]}
          requiredModule="TelemetryModule"
        />
        <PrivateRoute
          path="/configurations"
          component={Configuration}
          userAccessLevel={[1, 2, 3]}
        />
        <PrivateRoute
          exact
          path="/parts"
          component={Search}
          userAccessLevel={[1, 2, 3]}
          requiredModule="DailyPartsModule"
        />
        <PrivateRoute
          path="/parts/list"
          component={DailyParts}
          userAccessLevel={[1, 2, 3]}
          requiredModule="DailyPartsModule"
        />
        <PrivateRoute
          path="/lineup"
          component={Lineup}
          userAccessLevel={[1, 2, 3]}
          requiredModule="LineupModule"
        />
        <PrivateRoute
          path="/admin"
          component={Admin}
          userAccessLevel={[1]}
        />
        <PrivateRoute
          path="/dynamic"
          component={Dynamic}
          userAccessLevel={[1, 2, 3]}
          requiredModule="DynamicModule"
        />
        <PrivateRoute
          path="/expedite"
          component={Expedite}
          userAccessLevel={[1, 2, 3]}
          requiredModule="ExpediteModule"
        />
        <PrivateRoute exact path="/passwordRedefinition" component={Password} />
        <Route path="*" component={() => <h1>{translate('common:PageNotFound')}</h1>} />
      </Switch>
      {renderZendeskWidget()}
    </BrowserRouter>
  );
};

export default Routes;
